// extracted by mini-css-extract-plugin
export default {"container":"CodeValidate_container__d8ppK","link":"CodeValidate_link__43g7I"};